import React, {Component} from "react";
import {connect} from "react-redux";
import {Button} from "primereact/button";
import * as management from "../../actions/management";
import {Toast} from 'primereact/toast';
import {Card} from 'primereact/card';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Redirect} from "react-router-dom";
import * as auth from "../../actions/auth";


class GeneralSettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            file_content: null,
            file_name: null,
            content_list: [],
            email: [],
            postgres: [],
            mongodb: [],
            other: [],
            postgres_con: null,
            mongodb_con: null,
            email_con: null,
            gen_settings_role: localStorage.getItem('gen_settings') ? true : false,
        };

        this.logChange = this.logChange.bind(this);

    }

    showSuccess(message) {
        this.growl.show({severity: 'success', summary: message, detail: ''});
    }

    showError(message) {
        this.growl.show({severity: 'error', summary: message, detail: ''});
    }

    logChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentDidMount() {
        this.getModels();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            const management = nextProps.management;
            if (this.props.management !== management) {


            }
        }
    }

    getModels() {
        let headers = {"Content-Type": "application/json"};
        const token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/general_settings/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            const content_list = data.content_list;
                            this.setState({
                                file_name: data.file_name,
                                code: data.file_content,
                                email: content_list.email,
                                postgres: content_list.postgres,
                                mongodb: content_list.mongodb,
                                other: content_list.other,
                            })
                        }

                        this.setState({projects: res.data.projects});
                    }else if (res.status === 401) {
                        this.props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    onSubmit = e => {
        e.preventDefault();
        const data = {
            'file_content': this.state.code
        }
        this.props.putMethod(data, "/api/general_settings/", "UPDATE_GENERAL_SETTINGS");

    };

    getConnectionTest(setting_type) {
        let headers = {"Content-Type": "application/json"};
        const token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/general_settings/test_connection/' + setting_type + '/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            this.showSuccess(data.message);
                            if (setting_type === "postgres")
                                this.setState({postgres_con: true})
                            else if (setting_type === "mongodb")
                                this.setState({mongodb_con: true})
                            else if (setting_type === "email")
                                this.setState({email_con: true})
                        } else {
                            this.showError(data.message);
                            if (setting_type === "postgres")
                                this.setState({postgres_con: false})
                            else if (setting_type === "mongodb")
                                this.setState({mongodb_con: false})
                            else if (setting_type === "email")
                                this.setState({email_con: false})
                        }

                        this.setState({projects: res.data.projects});
                    } else if (res.status === 401) {
                        this.props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    render() {

        const postgres = this.state.postgres;
        const email = this.state.email;
        const mongodb = this.state.mongodb;
        const other = this.state.other;
        let postgresItems = postgres.map((data, index) => (
                <div className="p-grid" key={index}>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-3"><b>{data.key}</b>:</div>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-9">
                        {data.value}
                    </div>
                </div>
            )
        );
        let emailItems = email.map((data, index) => (
                <div className="p-grid" key={index}>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-3"><b>{data.key}</b>:</div>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-9">
                        {data.value}
                    </div>
                </div>
            )
        );
        let mongodbItems = mongodb.map((data, index) => (
                <div className="p-grid" key={index}>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-3"><b>{data.key}</b>:</div>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-9">
                        {data.value}
                    </div>
                </div>
            )
        );
        let otherItems = other.map((data, index) => (
                <div className="p-grid" key={index}>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-3"><b>{data.key}</b>:</div>
                    <div className="p-col-12 p-md-6 p-sm-12 p-lg-9">
                        {data.value}
                    </div>
                </div>
            )
        );
        if (this.state.gen_settings_role) {
            return (
                <div>
                    <Toast ref={(el) => this.growl = el}/>
                    <Card
                        style={{marginTop: '3px'}}
                        title="Genel Ayarlar"
                    >
                        <hr/>
                        <div className="content-section implementation">
                            <Accordion
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => this.setState({activeIndex: e.index})}>
                                <AccordionTab header="Postgresql">
                                    {postgresItems}
                                    <div className="p-grid">
                                        <Button
                                            label="Test Et"
                                            className="p-button-secondary"
                                            onClick={() => this.getConnectionTest("postgres")}
                                        />
                                        <i className="pi pi-check" style={{
                                            'fontSize': '2em',
                                            color: 'green',
                                            display: this.state.postgres_con === true ? 'block' : "none"
                                        }}/>
                                        <i className="pi pi-times"
                                           style={{
                                               'fontSize': '2em',
                                               color: 'red',
                                               display: this.state.postgres_con === false ? 'block' : "none"
                                           }}
                                        />
                                    </div>
                                </AccordionTab>
                                <AccordionTab header="Mongodb">
                                    {mongodbItems}
                                    <div className="p-grid">
                                        <Button
                                            label="Test Et"
                                            className="p-button-secondary"
                                            onClick={() => this.getConnectionTest("mongodb")}
                                        />
                                        <i className="pi pi-check" style={{
                                            'fontSize': '2em',
                                            color: 'green',
                                            display: this.state.mongodb_con === true ? 'block' : "none"
                                        }}/>
                                        <i className="pi pi-times"
                                           style={{
                                               'fontSize': '2em',
                                               color: 'red',
                                               display: this.state.mongodb_con === false ? 'block' : "none"
                                           }}
                                        />
                                    </div>
                                </AccordionTab>
                                <AccordionTab header="Email">
                                    {emailItems}
                                    <div className="p-grid">
                                        <Button
                                            label="Test Et"
                                            className="p-button-secondary"
                                            onClick={() => this.getConnectionTest("email")}
                                        />
                                        <i className="pi pi-check" style={{
                                            'fontSize': '2em',
                                            color: 'green',
                                            display: this.state.email_con === true ? 'block' : "none"
                                        }}/>
                                        <i className="pi pi-times"
                                           style={{
                                               'fontSize': '2em',
                                               color: 'red',
                                               display: this.state.email_con === false ? 'block' : "none"
                                           }}
                                        />
                                    </div>
                                </AccordionTab>
                                <AccordionTab header="Diğer Ayarlar">
                                    {otherItems}
                                </AccordionTab>
                            </Accordion>

                        </div>
                    </Card>
                </div>
            );
        } else {
            return (
                <Redirect to="/notfound"/>
            )
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        deleteMethodByOnlyId: (url, id, props_type) => {
            return dispatch(management.deleteMethodByOnlyId(url, id, props_type));
        },
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        }, loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/pages/generalsettings/GeneralSettings.jsx